import React from "react";
import image_8 from "../../images/agriculture/Picture10.webp";
import image_9 from "../../images/agriculture/Picture11.webp";
import image_10 from "../../images/agriculture/Picture12.webp";
import image_1 from "../../images/agriculture/Picture2.webp";
import image_2 from "../../images/agriculture/Picture4.webp";
import image_3 from "../../images/agriculture/Picture5.webp";
import image_4 from "../../images/agriculture/Picture6.webp";
import image_5 from "../../images/agriculture/Picture7.webp";
import image_6 from "../../images/agriculture/Picture8.webp";
import image_7 from "../../images/agriculture/Picture9.webp";

const imgData = [
  {
    id: 1,
    image: image_2,
    name: "Fruits",
  },
  {
    id: 2,
    image: image_3,
    name: "Vegetables",
  },
  {
    id: 3,
    image: image_4,
    name: "Nuts",
  },
  {
    id: 4,
    image: image_5,
    name: "Cheese",
  },
  {
    id: 5,
    image: image_6,
    name: "Marmalade",
  },
  {
    id: 6,
    image: image_7,
    name: "Sundried",
  },
  {
    id: 7,
    image: image_8,
    name: "Herbs",
  },
  {
    id: 8,
    image: image_9,
    name: "Oils",
  },
  {
    id: 9,
    image: image_10,
    name: "Spices",
  },
];

const ProductRange = () => {
  return (
    <section className="" id="product-range">
      <div className="product-range-container">
        <div className="ms-13 me-13 pt-7 pb-7 text-center">
          <img src={image_1} className="img-fluid" alt="" />
          <h1 className="fs-56 lh-64 text-uppercase gilroy-bold text-white pt-5">
            Product Range
          </h1>
        </div>
      </div>
      <div className="bg-chinese-black">
        <div className="ms-47 me-47 pt-7 pb-7">
          <div className="row">
            {imgData.map((data) => (
              <div className="col-md-4 col-xl-4 text-center p-5" key={data?.id}>
                <div className="bg-white h-100 card-design-2">
                  <img src={data?.image} className="product-img" alt="" />
                  <p className="fs-20 gilroy-bold">{data?.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductRange;
